export const authEndpoint = "https://accounts.spotify.com/authorize";
const clientId = "92cb880c3f0b4c87984f1c455c16e979";
const isDevelopmentEnv = process.env.NODE_ENV !== "production";
const redirectUri = isDevelopmentEnv
  ? "http://localhost:3000/"
  : "https://music-spotify.netlify.app/";
const scopes = [
  "user-read-currently-playing",
  "user-read-recently-played",
  "user-read-playback-state",
  "user-top-read",
  "user-modify-playback-state",
];

export const getTokenFromResponse = () => {
  return window.location.hash
    .substring(1)
    .split("&")
    .reduce((initial, item) => {
      var parts = item.split("=");
      initial[parts[0]] = decodeURIComponent(parts[1]);
      return initial;
    }, {});
};

export const accessUrl = `${authEndpoint}?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scopes.join(
  "%20"
)}&response_type=token&show_dialog=true`;
